import React, { useState, useEffect } from "react";
import { IconButton, Popover, Checkbox, FormControlLabel, Grid} from "@mui/material";
import SortIcon from "@mui/icons-material/Sort";
import CloseIcon from "@mui/icons-material/Close";

const SortMenu = (props: any) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [selectedOption, setSelectedOption] = useState<string | null>("");
  const originalList = [...props.list]; 

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleOptionChange = (option: string) => {
    setSelectedOption(option);
  };

  const applySorting = () => {
    let sortedList = [...originalList]; 

    if (selectedOption === "Low Tuition Fee") {
      sortedList = sortedList.sort((a, b) => a.tuitionFee.tuitionFee - b.tuitionFee.tuitionFee);
    } else if (selectedOption === "High Tuition Fee") {
      sortedList = sortedList.sort((a, b) => b.tuitionFee.tuitionFee - a.tuitionFee.tuitionFee);
    } else if (selectedOption === "Low Duration") {
      sortedList = sortedList.sort((a, b) => a.duration?.duration - b.duration?.duration);
    } else if (selectedOption === "High Duration") {
      sortedList = sortedList.sort((a, b) => b.duration?.duration - a.duration?.duration);
    }

    props.setList(sortedList);
  };
    const options = [
      { label: "Low Tuition Fee", value: "Low Tuition Fee" },
      { label: "High Tuition Fee", value: "High Tuition Fee" },
      // { label: "Low Duration", value: "Low Duration" },
      // { label: "High Duration", value: "High Duration" },
    ];
    
  useEffect(() => {
    applySorting(); 
    // eslint-disable-next-line
  }, [selectedOption]);

  const open = Boolean(anchorEl);

  return (
    <div>
      <IconButton onClick={handleClick} sx={{marginRight:"1rem"}}>
        <SortIcon sx={{color:"#000"}}/>
      </IconButton>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <Grid container spacing={1} sx={{ padding: 2, width: 200 }}>
          <Grid item xs={12} sx={{ display:{ lg:"none",xs:"flex"}, justifyContent: "space-between" }}>
            <IconButton onClick={handleClose}>
              <CloseIcon sx={{ fontSize: "1.25rem" }} />
            </IconButton>
          </Grid>
          <Grid item xs={12} sx={{ "& .MuiTypography-root": { fontSize: "14px" } }}>
      {options.map((option) => (
        <FormControlLabel
          key={option.value}
          control={
            <Checkbox
              checked={selectedOption === option.value}
              onChange={() => handleOptionChange(option.value)}
              sx={{ "& .MuiSvgIcon-root":{fontSize: "1.25rem"}}}
            />
          }
          label={option.label}
        />
      ))}
    </Grid>
        </Grid>
      </Popover>
    </div>
  );
};

export default SortMenu;
